import React, { useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'

const PersonalInformationCorrection = () => {
      const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    additionalInfo: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };
  return (
    <div className='bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300'>
        <Header />
        <div className="flex items-center justify-center px-4 py-12">
      <div className="max-w-lg w-full">
        <h2 className="text-3xl font-bold text-center mb-8">
          Name Correction Appeal
        </h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Original Name */}
          <div>
            <label className="block text-lg font-semibold">
              Original name
            </label>
            <p className="text-gray-500 mt-1">Oops, something went wrong.</p>
          </div>

          {/* Correct Name */}
          <div>
            <label className="block text-md font-semibold mb-2">
              Correct Name
            </label>
            <input
              type="text"
              name="firstName"
              placeholder="First name"
              value={formData.firstName}
              onChange={handleChange}
              className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400 bg-transparent"
              required
            />
            <input
              type="text"
              name="middleName"
              placeholder="Middle name (Optional)"
              value={formData.middleName}
              onChange={handleChange}
              className="w-full border rounded-md px-3 py-2 mt-3 focus:outline-none focus:ring-2 focus:ring-yellow-400 bg-transparent"
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last name"
              value={formData.lastName}
              onChange={handleChange}
              className="w-full border rounded-md px-3 py-2 mt-3 focus:outline-none focus:ring-2 focus:ring-yellow-400 bg-transparent"
              required
            />
          </div>

          {/* Additional Info */}
          <div>
            <label className="block text-md font-semibold">
              Additional Information (Optional)
            </label>
            <textarea
              name="additionalInfo"
              placeholder="Please describe the information you would like to add."
              value={formData.additionalInfo}
              onChange={handleChange}
              className="w-full border rounded-md px-3 py-2 mt-2 h-28 resize-none focus:outline-none focus:ring-2 focus:ring-yellow-400 bg-transparent"
            ></textarea>
          </div>

          {/* Submit Button */}
          <div>
            <button
              type="submit"
              className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-2 px-4 rounded-md transition"
            >
              Submit
            </button>
          </div>
        </form>

        {/* Note */}
        <p className="text-xs text-gray-500 mt-4">
          Please note: Once your name is changed, system will trigger various
          verification flows automatically. This may affect your correlating
          functions temporary or permanently. Make sure to input the exact full
          name on your verified document.
        </p>
        <p className="text-xs text-gray-500 mt-1">Please make sure if it’s necessary to change your name before applying for it. The consequences of any change may include, but will not be limited to, the following:</p>
        <ul className="mt-2"></ul>
          <li className="text-sm text-gray-500 mt-2">1. Fiat exchange may be forbidden or your fiat limits may be lowered temporarily or permanently.</li>
          <li className="text-sm text-gray-500 mt-2">2. P2P exchange may be forbidden or your P2P limits may be lowered temporarily or permanently.</li>
          <li className="text-sm text-gray-500 mt-2">3. Crypto exchange may be forbidden or your exchange limits may be lowered temporarily or permanently.</li>
          <li className="text-sm text-gray-500 mt-2">4. Various functions maybe forbidden due to risk management.</li>
      </div>
    </div>
    <Footer />
    </div>
  )
}

export default PersonalInformationCorrection